import React, { useMemo } from 'react';
import classNames from 'classnames';

import { useQuickPositionChatsNavigationQuery } from 'interfaces/graphql-typings';

import DownArrowIcon from 'buyside/svgs/down_arrow.svg';
import UpArrowIcon from 'buyside/svgs/up_arrow.svg';

import { UseChatNavigationType } from 'buyside/components/presentation/ChatLayout/ChatNavigation/chatNavigation';

import styles from './chatNavigationStyles.scss';

const useQuickPositionNavigation = (): UseChatNavigationType => {
  const { data, loading } = useQuickPositionChatsNavigationQuery();

  const navigationItems = useMemo(
    () =>
      data?.currentUser?.openQuickPositions?.map(
        ({
          direction,
          chat: { id: chatId, unreadMessagesCount },
          asset: {
            entity: { name },
            symbol
          }
        }) => ({
          subtitle: (
            <p>
              <span
                className={classNames(styles.directionArrow, {
                  [styles.green]: direction === 'long'
                })}
              >
                {direction === 'long' ? <UpArrowIcon /> : <DownArrowIcon />}
              </span>
              {symbol}
            </p>
          ),
          title: `${name}`,
          to: '/' + chatId,
          unreadMessagesCount
        })
      ) || [],
    [data?.currentUser?.openQuickPositions]
  );

  return {
    loading,
    indexNavigationItem: { title: 'All Positions', to: '/' },
    navigationItems,
    navigationTitle: 'Your Quick Positions'
  };
};

export default useQuickPositionNavigation;
